import React from "react";
import { useMediaQuery } from 'react-responsive'
import "./styles/images.css"

function Logo() {
    const isMobileLarge = useMediaQuery({ query: '(height > 1616px)' });

    return (
        <img
            className="nav-logo"
            src="../images/razul-logo-transparent.png"
            alt="Razul Logo"
            style={isMobileLarge ? { height: '32px' } : undefined}
        />
    );
}

export default Logo;